import axios from "axios";
import { gatewayUrl } from "@Constants/gatewayUrl";
import { createConfig } from "@Utils/createConfig";
const ROLE_SUFFIX = /\s*\((body|headings?)\)\s*$/i;
const fontKey = (fontName)=>fontName.replace(ROLE_SUFFIX, "").replace(/\s+/g, "").toLowerCase();
/** Registry family name for a style's font ("TimesNewRoman", "Calibri (Body)"), else the name as given. */ export function resolveFontFamily(fontName, { families }) {
    if (!fontName) return undefined;
    const key = fontKey(fontName);
    const match = families.find((family)=>[
            family.name,
            ...family.aliases
        ].some((spelling)=>fontKey(spelling) === key));
    return match?.name ?? fontName.replace(ROLE_SUFFIX, "");
}
async function fetchRegistry(token) {
    const config = createConfig(token);
    const [css, families] = await Promise.all([
        axios.get(`${gatewayUrl}/fonts/css`, {
            ...config,
            responseType: "text"
        }),
        axios.get(`${gatewayUrl}/fonts/families`, config)
    ]);
    const style = document.createElement("style");
    style.dataset.juristicFontRegistry = "true";
    style.textContent = css.data;
    document.head.appendChild(style);
    return {
        families: families.data
    };
}
let registryPromise;
/** Injects the org's `@font-face` CSS once per session and returns the families for name matching. */ export function loadFontRegistry(token) {
    registryPromise ??= fetchRegistry(token).catch((error)=>{
        registryPromise = undefined;
        throw error;
    });
    return registryPromise;
}
